<template>
  <div class="card is-min-width-800" v-if="specialisationTiers">
    <div class="pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content pd-40px">
        <p class="is-size-3 has-text-weight-bold mgb-20px has-text-centered">
          {{$t('indexation.regie.popUpInflationClient.title', { regie: tiers.nomCommercial })}}
        </p>
        <div class="columns is-multiline">
          <div class="column is-12">
          </div>
          <div class="column is-12">
            <v-client-table :data="specialisationTiers"
                            class="vueTableFilterStyle
                            VueTableInputPaddingless
                            displayNoneVuePagination"
                            :columns="columns"
                            :options="options"
                            ref="tabSpecialisationTiers">
              <div slot="specialisationTiersNomCom" slot-scope="props">
                <b-autocomplete :open-on-focus="false"
                                v-if="props.row.isSearch"
                                :data="dataClients"
                                field="libelle"
                                :placeholder="$t('indexation.regie.popUpInflationClient.addClient')"
                                @input="getAsyncClientData"
                                :loading="isFetching"
                                @select="addClient">
                  <template slot="empty">
                    <div v-if="!isFetching">
                      {{$t('general.autocomplete.noRslt')}}
                    </div>
                    <div v-else>
                      {{$t('general.autocomplete.search')}}
                    </div>
                  </template>
                </b-autocomplete>
                <div v-else class="pd-5px">
                  {{ props.row.specialisationTiersNomCom }}
                </div>
              </div>
              <div slot="taux" slot-scope="props"
                   v-if="!props.row.isSearch">
                <b-input v-model="specialisationTiers[props.index - 1].taux"
                         type="number">
                </b-input>
              </div>
              <div slot="delete" slot-scope="props"
                   class="has-text-centered pd-5px"
                   v-if="!props.row.isSearch">
                <div @click="deleteSpe(props.index - 1)"
                     class="is-cursor-pointer">
                  <b-icon type="is-danger" icon="delete-forever"></b-icon>
                </div>
              </div>
            </v-client-table>
          </div>
        </div>
        <footer>
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal mgl-0"
            @click="$parent.close()">
            {{ $t('general.button.cancel')}}
          </button>
          <button
            class="button is-addOrEdit has-text-centered button-modal"
            @click="$emit('updateSpecialisationTiers',
            specialisationTiers.filter((tiersValue) => { return !tiersValue.isSearch; }))">
            {{ $t('general.button.terminer')}}
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { NO_PER_PAGE_VALUE, NO_PAGINATION, TEXTS } from '@/configuration/clientTableConf';
import { getAll } from '@/api/tiers';
import messageErreur from '@/services/general/messageErreur';
import { TIERS_TYPE_CLIENT, TIERS_SOUS_TYPE_AUCUN } from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';

export default {
  props: {
    listeSpecialisationTiers: {
      type: Array,
      required: true,
    },
    tiers: {
      type: Object,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      specialisationTiers: null,
      dataClients: [],
      isFetching: false,
    };
  },
  computed: {
    columns() {
      return ['specialisationTiersNomCom', 'taux', 'delete'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          specialisationTiersNomCom: this.$i18n.t('indexation.regie.popUpInflationClient.tab.client'),
          taux: this.$i18n.t('indexation.regie.popUpInflationClient.tab.taux'),
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        columnsClasses: {
          taux: 'colonneSelected',
          delete: 'colonneSelected',
        },
      };
    },
  },
  methods: {
    getAsyncClientData: debounce(async function clientData(text) {
      try {
        this.isFetching = true;
        this.dataClients = [];
        const clientList = (await getAll({
          query: {
            type: TIERS_TYPE_CLIENT,
            sousType: [TIERS_SOUS_TYPE_AUCUN],
            archive: false,
            societeId: this.societeId,
            nomsCommercialOuNomsJuridique: [text],
            tiersIdExclure: this.specialisationTiers
              .filter((tiers) => { return !tiers.isSearch; })
              .map((tiers) => tiers.specialisationTiersId),
          },
          limit: NO_PAGINATION,
        })).data.result.items;
        const clientListTransform = [];
        clientList.forEach((client) => {
          clientListTransform.push({
            tiersId: client.id,
            nomCommercial: client.nomCommercial,
            libelle: client.code + ' - ' + client.nomCommercial + ' - '
              + adressFullStringGetter(client.adressePostale, false),
          });
        });
        this.dataClients = clientListTransform;
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    addClient(client) {
      if (!client) return;
      this.specialisationTiers.push({
        specialisationTiersId: client.tiersId,
        specialisationTiersNomCom: client.nomCommercial,
        taux: 0,
        isSearch: false,
      });
    },
    deleteSpe(index) {
      this.specialisationTiers.splice(index, 1);
    },
  },
  mounted() {
    let listClient = [{
      specialisationTiersId: null,
      specialisationTiersNomCom: null,
      taux: null,
      isSearch: true,
    }];
    listClient = listClient.concat(cloneDeep(this.listeSpecialisationTiers));
    this.specialisationTiers = cloneDeep(listClient);
  },
};

</script>
